

export const ArrowDownIcon = () => {
    return (
        <svg
            width="15"
            height="9"
            viewBox="0 0 15 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M7.5 9L0 0L15 0L7.5 9Z" fill="black" />
        </svg>
    );
};
